import { FC, Children } from 'react';
import { Col, Row, Space, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import { theme } from '../../consts/themeBase';
import { Gallery as messages } from './messages';

interface GalleryProps {
  title?: string;
}

export const Gallery: FC<GalleryProps> = ({ title, children }) => (
  <Space direction="vertical">
    {title && <Typography.Title level={5}>{title}</Typography.Title>}
    {children ? (
      <Row gutter={[16, 16]}>
        {Children.map(children, photo => (
          <Col span={8}>{photo}</Col>
        ))}
      </Row>
    ) : (
      <Row justify="space-around">
        <Typography.Paragraph style={{ fontSize: 16, color: theme.colors.dark }}>
          <FormattedMessage {...messages.photosNotAvailable} />
        </Typography.Paragraph>
      </Row>
    )}
  </Space>
);
